import React, { useContext } from 'react';
import Loader from '../Loader/Loader';
import './loaderoverlay.scss';
import LoaderOverlayContext from './context';

const LoaderOverlay = () => {
  return (
    <>
      <div className="d-flex align-items-center justify-content-center w-100 position-fixed loader-overlay-container">
        <Loader />
      </div>
    </>
  );
};

const LoaderOverlayRoot = () => {
  const { visible } = useContext(LoaderOverlayContext);
  return visible ? <LoaderOverlay /> : null;
};

export default LoaderOverlayRoot;
